import { render, staticRenderFns } from "./Reddit.vue?vue&type=template&id=cf290ade&"
import script from "./Reddit.vue?vue&type=script&lang=js&"
export * from "./Reddit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports